<template>
    <div class="about">
        <div class="top-actions">
            <el-button type="default" size="small" icon="el-icon-refresh" @click="handleRefresh"></el-button>
            <el-button type="default" size="small" icon="el-icon-download" @click="handleExport">导出</el-button>
            <el-button type="danger" size="small" icon="el-icon-delete" @click="handleDeleteSelected">删除</el-button>

            <div class="search-container">
                <el-input placeholder="搜索" v-model="searchQuery" suffix-icon="el-icon-search" @input="handleSearch"></el-input>
                <el-button type="default" icon="el-icon-search" @click="showSearchFields = !showSearchFields"></el-button>
            </div>
        </div>
        <div v-if="showSearchFields" class="advanced-search-fields">
            <el-row :gutter="20">
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="任务ID">
                            <el-input v-model="searchForm.taskId" placeholder="请输入任务ID"></el-input>
                        </el-form-item>
                        <el-form-item label="任务名">
                            <el-input v-model="searchForm.taskName" placeholder="请输入任务名"></el-input>
                        </el-form-item>
                    </el-form>
                </el-col>
                <el-col :span="12">
                    <el-form :model="searchForm" label-width="100px">
                        <el-form-item label="采集源">
                            <el-input v-model="searchForm.collectionSource" placeholder="请输入采集源"></el-input>
                        </el-form-item>
                        <el-form-item label="创建时间">
                            <el-date-picker
                                v-model="searchForm.creationTime"
                                type="date"
                                placeholder="选择日期"
                                value-format="yyyy-MM-dd">
                            </el-date-picker>
                        </el-form-item>
                    </el-form>
                </el-col>
            </el-row>
            <el-button type="primary" @click="handleAdvancedSearch">提交</el-button>
            <el-button type="default" @click="showSearchFields = false">取消</el-button>
        </div>

        <el-table
            ref="filterTable"
            :data="paginatedTableData"
            :header-cell-style="{color:'#606266',background:'#f5f7fa'}"
            style="width: 100%"
            stripe
            border
            @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="55"></el-table-column>
            <el-table-column prop="id" label="任务id" sortable width="180"></el-table-column>
            <el-table-column prop="nickname" label="昵称"></el-table-column>
            <el-table-column prop="content" label="评论内容"></el-table-column>
            <el-table-column prop="sec_uid" label="评论ID"></el-table-column>
            <el-table-column prop="time" label="采集时间"></el-table-column>
            <!-- 其他列根据需要添加 -->
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                    <el-button size="mini" type="primary" @click="handleCopyHomepage(scope.row)">复制主页</el-button>
                </template>
            </el-table-column>
        </el-table>

        <div class="pagination">
            <el-pagination
                background
                layout="total, sizes, prev, pager, next, jumper"
                :current-page="currentPage"
                :page-sizes="[50, 100, 200]"
                :page-size="pgSize"
                :total="filteredTableData.length"
                @size-change="handleSizeChange"
                @current-change="handlePageChange">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import { bilibili_video_comments, bilibili_video_comments2, bilibili_video_comments3,bilibili_video_comments8,bilibili_video_comments4, delete_bilibili_video_comment } from '@/api/bili';
import moment from 'moment';
import XLSX from 'xlsx';
import { saveAs } from 'file-saver';

export default {
    data() {
        return {
            currentPage: 1,       // 当前页码
            pgSize: 50,           // 每页显示50条
            idx: -1,
            editVisible: false,
            form: {},
            searchQuery: '',      // 简单搜索关键词
            showSearchFields: false, // 是否显示高级搜索
            searchForm: {
                taskId: '',
                taskName: '',
                collectionSource: '',
                creationTime: ''
            },
            selectedRows: [],     // 选中的行
            tableData: []         // 表格数据
        }
    },
    computed: {
        // 过滤后的数据（包含搜索和高级搜索）
        filteredTableData() {
            let data = [...this.tableData];
            
            // 简单搜索
            if (this.searchQuery) {
                const query = this.searchQuery.toLowerCase();
                data = data.filter(item => 
                    Object.values(item).some(value => 
                        String(value).toLowerCase().includes(query)
                    )
                );
            }
            
            // 高级搜索
            if (this.searchForm.taskId) {
                data = data.filter(item => 
                    String(item.id).includes(this.searchForm.taskId)
                );
            }
            
            if (this.searchForm.taskName) {
                data = data.filter(item => 
                    item.nickname.toLowerCase().includes(this.searchForm.taskName.toLowerCase())
                );
            }
            
            if (this.searchForm.collectionSource) {
                data = data.filter(item => 
                    String(item.collectionSource).toLowerCase().includes(this.searchForm.collectionSource.toLowerCase())
                );
            }
            
            if (this.searchForm.creationTime) {
                const date = this.searchForm.creationTime;
                data = data.filter(item => 
                    moment(item.time).format('YYYY-MM-DD') === date
                );
            }
            
            return data;
        },
        // 分页后的数据
        paginatedTableData() {
            const start = (this.currentPage - 1) * this.pgSize;
            const end = start + this.pgSize;
            return this.filteredTableData.slice(start, end);
        }
    },
    created() {
        this.fetchData();
    },
    methods: {
        // 根据用户角色获取对应的API
        getApiByRole() {
            const userRole = localStorage.getItem('userRole') || 'admin';
            
            const apiMap = {
                'admin': bilibili_video_comments,
                'manager': bilibili_video_comments2,
                'zhuzhu': bilibili_video_comments3,
                 'huolong': bilibili_video_comments3,
                'buzhi': bilibili_video_comments3,
                'ruiqi': bilibili_video_comments3,
                'daolai': bilibili_video_comments3,
                'yangguang': bilibili_video_comments3,
                'demo': bilibili_video_comments3,
                'jinlianan': bilibili_video_comments3,
                'jinlianan2': bilibili_video_comments3,
                 'dianguang1':bilibili_video_comments3,
                'dianguang2': bilibili_video_comments3,
                'dianguang3': bilibili_video_comments3,
                 'demo': bilibili_video_comments8,
                
                
            };
            
            return apiMap[userRole] || bilibili_video_comments;
        },
        fetchData() {
            const api = this.getApiByRole();
            api().then(response => {
                this.tableData = response.data.map(item => ({
                    id: item.user_id,
                    nickname: item.nickname, 
                    note: item.note_url, 
                    content: item.content, 
                    xhsid: item.nickname,
                    count: item.comment_count,
                    time: item.create_time, 
                    user_id: item.user_id,
                    sec_uid: item.sec_uid,
                }));
            }).catch(error => {
                console.error('获取数据时出错！', error);
                this.$message.error('获取数据失败');
            });
        },
        handleRefresh() {
            this.fetchData();
        },
        handleCopyHomepage(row) {
            const user_id = row.user_id;
            const homepageUrl = `https://space.bilibili.com/${user_id}`;
            if (homepageUrl) {
                navigator.clipboard.writeText(homepageUrl).then(() => {
                    this.$message.success('主页链接已复制到剪贴板');
                }).catch(err => {
                    this.$message.error('无法复制主页链接');
                });
            } else {
                this.$message.warning('没有找到主页链接');
            }
        },
        handleExport() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要导出的行！');
                return;
            }

            const dataToExport = this.selectedRows.map(item => {
                const user_id = item.user_id;
                const homepageUrl = `https://space.bilibili.com/${user_id}`;
                return {
                    "任务id": item.user_id,
                    "昵称": item.nickname,
                    "评论内容": item.content,
                    "评论ID": item.sec_uid,
                    "采集时间": this.formatDate(item.time),
                    "主页链接": homepageUrl
                };
            });

            const worksheet = XLSX.utils.json_to_sheet(dataToExport);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

            const wbout = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: "application/octet-stream" });
            saveAs(blob, '导出数据.xlsx');
        },
        handleAdvancedSearch() {
            if (!this.searchForm.creationTime) {
                this.$message.warning('请选择创建时间！');
                return;
            }

            const params = {
                taskId: this.searchForm.taskId,
                taskName: this.searchForm.taskName,
                collectionSource: this.searchForm.collectionSource,
                creationTime: this.searchForm.creationTime
            };

            // 假设这里有一个API来处理高级搜索，需要根据实际情况调整
            // 这里只是一个示例，实际应根据你的API进行调整
            // 例如，如果有一个高级搜索API，可以这样调用：
            // advancedSearchApi(params).then(response => {
            //     this.tableData = response.data;
            // }).catch(error => {
            //     console.error('高级搜索出错！', error);
            // });

            // 由于没有具体的高级搜索API，这里暂时模拟一下
            // 你可以根据实际情况修改这部分代码

            // 模拟高级搜索结果
            const filteredData = this.tableData.filter(item => {
                let match = true;
                if (this.searchForm.taskId && !String(item.id).includes(this.searchForm.taskId)) {
                    match = false;
                }
                if (this.searchForm.taskName && !item.nickname.toLowerCase().includes(this.searchForm.taskName.toLowerCase())) {
                    match = false;
                }
                if (this.searchForm.collectionSource && !String(item.collectionSource).toLowerCase().includes(this.searchForm.collectionSource.toLowerCase())) {
                    match = false;
                }
                if (this.searchForm.creationTime && moment(item.time).format('YYYY-MM-DD') !== this.searchForm.creationTime) {
                    match = false;
                }
                return match;
            });

            this.tableData = filteredData;
            this.currentPage = 1; // 重置到第一页
            this.showSearchFields = false;
        },
        handleDeleteSelected() {
            if (this.selectedRows.length === 0) {
                this.$message.warning('请先选择要删除的行！');
                return;
            }

            const userIds = this.selectedRows.map(row => row.user_id);
            this.$confirm('确定要删除选中的记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                Promise.all(userIds.map(id => delete_bilibili_video_comment(id)))
                    .then(() => {
                        this.$message.success('删除成功');
                        this.fetchData(); // 刷新数据以反映删除
                        this.selectedRows = []; // 清空选中项
                    })
                    .catch(error => {
                        this.$message.error('部分删除失败');
                        console.error('批量删除时出错！', error);
                    });
            }).catch(() => {});
        },
        // 删除单行
        handleDelete(index, row) {
            this.$confirm('确定要删除这条记录吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delete_bilibili_video_comment(row.user_id).then(() => {
                    this.$message.success('删除成功');
                    this.fetchData(); // 刷新数据以反映删除
                }).catch(error => {
                    this.$message.error('删除失败');
                    console.error('删除时出错！', error);
                });
            }).catch(() => {});
        },
        handlePageChange(val) {
            this.currentPage = val;
        },
        handleSizeChange(val) {
            this.pgSize = val;
            this.currentPage = 1; // 重置到第一页
        },
        handleSelectionChange(selection) {
            this.selectedRows = selection;
        },
        formatDate(dateString) {
            if (!dateString) return '';
            return moment(dateString).format('YYYY-MM-DD HH:mm:ss');
        },
        // 简单搜索
        handleSearch() {
            this.currentPage = 1; // 搜索后重置到第一页
        }
    }
}
</script>


<style lang="stylus">
.top-actions
    display flex
    align-items center
    justify-content space-between
    margin-bottom 10px

.search-container
    margin-left: auto

.button-container
    margin-right: auto

.advanced-search-fields {
    margin-bottom: 10px;
}


</style>